/**
 * A review's date as the section shows it: an ISO day becomes "Jan 15, 2024",
 * and anything else (the API's "2 weeks ago") shows as given.
 * @param {string} [date] The review's date, as stored.
 * @returns {string | undefined} The date to show, or undefined when there is none.
 */
const formatReviewDate = (date?: string): string | undefined => {
  if (date === undefined || date === "") {
    return undefined;
  }
  if (/^\d{4}-\d{2}-\d{2}$/u.test(date)) {
    const parsed = new Date(`${date}T00:00:00`);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    }
  }
  return date;
};

export { formatReviewDate };
